import React from "react";
import cx from "classnames";
import _ from "lodash";
import ControlAddon from "./ControlAddon";
import ControlGroup from "./ControlGroup";
import ControlLabel from "./ControlLabel";
import ControlStatic from "./ControlStatic";
import InputControl from "./InputControl";

const DEFAULT_LABEL_AREA = "90px";
const DEFAULT_INPUT_AREA = "auto";

class FormControl extends React.Component {
  static defaultProps = {
    baseClassName: "si-c-form-control",
    labelArea: DEFAULT_LABEL_AREA,
    inputArea: DEFAULT_INPUT_AREA,
  };

  constructor(props) {
    super(props);

    this.id = _.get(props, "id", _.uniqueId("si-ctrl_"));
  }

  getValue = () => this.input.getValue();

  _setInputRef = (element) => {
    this.input = element;
  };

  render() {
    let {
      baseClassName,
      groupClass,
      type,
      label,
      addonAfter,
      labelArea,
      inputArea,
      inputStyle,
      labelStyle,
      error,
      wide, // configures input to span entire area
      style,
      ...otherProps
    } = this.props;

    let groupClasses = "";
    let Component = InputControl;
    let componentClassName = "";

    switch (type) {
      case "textarea":
        groupClasses = "layout-fill";

        break;
      case "radio":
      case "checkbox":
        groupClasses = "layout-cb-radio";

        if (DEFAULT_LABEL_AREA === labelArea) {
          labelArea = "18px";
        }

        break;
      case "static":
        Component = ControlStatic;
        componentClassName = `${baseClassName}__static`;

        break;
      default:
        break;
    }

    if (wide || _.isEmpty(label)) {
      groupClasses = "layout-fill";
    }

    if (error) {
      groupClasses += ` ${baseClassName}--error`;
    }

    const groupStyle = {
      gridTemplateColumns: `${labelArea} ${inputArea}`,
    };

    labelStyle = {
      ...labelStyle,
      margin: 0,
    };

    return (
      <ControlGroup
        baseClassName={baseClassName}
        className={cx(groupClasses, groupClass)}
        style={groupStyle}
      >
        <Component
          ref={type !== "static" ? this._setInputRef : null}
          id={this.id}
          type={type}
          style={inputStyle}
          className={componentClassName}
          {...otherProps}
        />
        {label ? <ControlLabel text={label} style={labelStyle} htmlFor={this.id} /> : null}
        {addonAfter ? (
          <ControlAddon baseClassName="si-c-input-suffix" className={`${baseClassName}__unit`}>
            {addonAfter}
          </ControlAddon>
        ) : null}
        {error ? <ControlStatic className={`${baseClassName}__error`} text={error} /> : null}
      </ControlGroup>
    );
  }
}

export default FormControl;
